export default "__VITE_ASSET__ba90d3da__"